import { ApiType } from "@gymflow/common";
import { UserMemberPost } from "@gymflow/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { memberAsPublicQueryKeys } from "./memberAsPublicQueryKeys";

export function useMemberCreateAsPublic({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (newMember: UserMemberPost) =>
      api.public.userMemberApi.create(newMember),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: memberAsPublicQueryKeys.all(),
      });
    },
  });
}
